import { TYPE_STRING } from './input-types';

export const id = 'notes';
export const apiKey = 'note';
export const type = TYPE_STRING;

export const notes = {
  id,
  apiKey,
  type,
};
